function ChatIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 10h-2v9H10v2c0 .55.45 1 1 1h11l4 4V11c0-.55-.45-1-1-1zm-4 6V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
        fill="#000"
      />
    </svg>
  )
}

export default ChatIcon
